<div class="modal-header" id="start-work-modal-title">
    <h3 class="modal-title" translate="FREQUENT_ACTIVITIES_BUTTON_START_WORK_LABEL"></h3>
    <span class="close" (click)="modalInstance.hide()">&times;</span>
</div>
<div class="modal-body" id="modal-body">
    <div class="row" *ngIf="model.endOfWork">
        <div class="col-5">
            <label translate="START_WORK_END_OF_WORK_LABEL"></label>
        </div>
        <div class="col-4">
            <span>{{ model.endOfWorkDate }}</span>
        </div>
        <div class="col-3">
            <span>{{ model.endOfWorkTime }}</span>
        </div>
    </div>
    <div class="row" *ngIf="!model.endOfWork">
        <span class="col-12" translate="START_WORK_ERROR_EMPTY_END_OF_WORK_MESSAGE"></span>
    </div>
    <div class="row">
        <div class="col-5">
            <label translate="START_WORK_START_OF_WORK_LABEL"></label>
        </div>
        <div class="col-4">
            <span>{{ model.startOfWorkDate }}</span>
        </div>
        <div class="col-3">
            <span>{{ model.startOfWorkTime }}</span>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button
        class="btn btn-primary"
        type="button"
        (click)="saveStartWork()"
        translate="START_WORK_BUTTON_SAVE_START_WORK_LABEL"
    ></button>
</div>
